export const advisorOptions = [
  {
    id: 'home',
    label: 'My whole home',
    description: 'Solar on the roof, want to use it at night',
    productId: 'ampra-stack',
  },
  {
    id: 'balcony',
    label: 'Balcony solar',
    description: 'A few panels, plug into a socket',
    productId: 'zendure-solarflow-2400',
  },
  {
    id: 'mobile',
    label: 'Camping & backup',
    description: 'Portable power, away or in outages',
    productId: 'ecoflow-delta-3-plus',
  },
] as const;
